export enum KnowEdmTableData {
  GeothermalTempDefinitionName = 'geothermalTempDefinitionName',
  DrillFloorTemperature = 'drillFloorTemperature',
  SeabedTemperature = 'seabedTemperature', 
  TemperatureGradient = 'temperatureGradient',
  TemperatureAtTD = 'temperatureAtTD',
  TemperatureAtDepth = 'temperatureAtDepth',
  DepthTVDTemperatureAtDepth = 'depthTVDTemperatureAtDepth',
  ReferenceDepth = 'referenceDepth',
  DepthMD = 'depthMD',
  Temperature = 'temperature',
}
